const trimRight = (value) => String(value || '').replace(/\/+$/, '')

export const isCognitoPasswordMode = (authMode) =>
  String(authMode || '').trim() === 'cognito-password'

const buildUrl = (apiBaseUrl, path) => `${trimRight(apiBaseUrl)}${path}`

export const createCognitoAuthClient = ({ apiBaseUrl, fetcher }) => ({
  login(data) {
    return fetcher({
      url: buildUrl(apiBaseUrl, '/api/auth/cognito/login'),
      method: 'post',
      data,
    })
  },

  completeNewPassword(data) {
    return fetcher({
      url: buildUrl(apiBaseUrl, '/api/auth/cognito/complete-new-password'),
      method: 'post',
      data,
    })
  },

  forgotPassword(data) {
    return fetcher({
      url: buildUrl(apiBaseUrl, '/api/auth/cognito/forgot-password'),
      method: 'post',
      data,
    })
  },

  confirmForgotPassword(data) {
    return fetcher({
      url: buildUrl(apiBaseUrl, '/api/auth/cognito/confirm-forgot-password'),
      method: 'post',
      data,
    })
  },

  callback(search) {
    return fetcher({
      url: buildUrl(apiBaseUrl, `/api/auth/cognito/session-callback${search || ''}`),
      method: 'get',
    })
  },
})
